import { withTranslation } from 'react-i18next'
import Widgets from './Widgets'

export default withTranslation()(Widgets) as any
